// src/common/Pagination.jsx
import React, { useMemo } from "react";

const Pagination = ({
  currentPage,
  totalPages,
  onPageChange,
  pageSize,
  onPageSizeChange,
  totalItems, // NEW: dynamic total items count for setting dropdown bounds
  itemName = "Items", 
  maxVisible = 5, 
}) => {



  const showingText = useMemo(() => {
    if (!totalItems) return "";
    const start = (currentPage - 1) * pageSize + 1;
    const end = Math.min(currentPage * pageSize, totalItems);
    return `Showing ${start} to ${end} of ${totalItems.toLocaleString()} ${itemName}`;
  }, [currentPage, pageSize, totalItems, itemName]);

  const pages = useMemo(() => {
    if (!totalPages || totalPages <= 0) return [];
    if (totalPages <= 7) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }

    const startPage = Math.max(1, currentPage - 2);
    const endPage = Math.min(totalPages, currentPage + 2);

    const result = [1];

    if (startPage > 2) {
      result.push("...");
    }

    for (let i = startPage; i <= endPage; i++) {
      if (i !== 1 && i !== totalPages) {
        result.push(i);
      }
    }

    if (endPage < totalPages - 1) {
      result.push("...");
    }

    if (totalPages > 1) {
      result.push(totalPages);
    }

    return result;
  }, [currentPage, totalPages]);

  return (
    <div className="d-flex flex-column align-items-center justify-content-center w-100 mt-4 mb-2">
      {/* Left side: Showing X of Y reports */}
      <div className="d-none d-md-block text-muted small fw-medium text-center mb-2 w-100">
        {showingText}
      </div>

      {/* Center Pagination Controls */}
      <div
        className="pagination-container d-flex align-items-center justify-content-center w-100 mb-3"
        style={{ gap: "4px" }}
      >
        <button
          type="button"
          className="btn btn-sm btn-light border fw-medium d-flex align-items-center gap-1"
          style={{
            height: "32px",
            padding: "0 12px",
            borderTopLeftRadius: "8px",
            borderBottomLeftRadius: "8px",
          }}
          disabled={currentPage === 1}
          onClick={() => onPageChange(currentPage - 1)}
        >
          &laquo; Previous
        </button>

        <div className="d-flex">
          {pages.map((p, i) =>
            p === "..." ? (
              <span key={`ellipsis-${i}`} className="px-2" style={{ lineHeight: "32px" }}>
                …
              </span>
            ) : (
              <button
                type="button"
                key={`page-${p}`}
                className={`btn btn-sm ${
                  p === currentPage ? "paginationBtn active" : "paginationBtn"
                }`}
                style={{ width: "32px", height: "32px", padding: "0" }}
                onClick={() => onPageChange(p)}
              >
                {p}
              </button>
            ),
          )}
        </div>

        <button
          type="button"
          className="btn btn-sm btn-light border fw-medium d-flex align-items-center gap-1"
          style={{ height: '32px', padding: '0 12px', borderTopRightRadius: "8px", borderBottomRightRadius: "8px" }}
          disabled={currentPage === totalPages}
          onClick={() => onPageChange(currentPage + 1)}
        >
          Next &raquo;
        </button>
      </div>
    </div>
  );
};

export default Pagination;